import { render, staticRenderFns } from "./PTableSelection.vue?vue&type=template&id=4ff69dc8"
import script from "./PTableSelection.vue?vue&type=script&lang=js"
export * from "./PTableSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports